import { Injectable, InjectionToken, inject } from '@angular/core';
import { ChatbotConfig, DEFAULT_CHATBOT_CONFIG } from '../models/chat-config.model';

export const CHATBOT_CONFIG_TOKEN = new InjectionToken<ChatbotConfig>('chatbot.config');

@Injectable({ providedIn: 'root' })
export class ChatConfigService {
  private readonly config = inject(CHATBOT_CONFIG_TOKEN, { optional: true }) || DEFAULT_CHATBOT_CONFIG;

  getApiBaseUrl(): string {
    return this.config.apiBaseUrl;
  }
  
  getConfig(): ChatbotConfig {
    return this.config;
  }
}

